import Pusher from "pusher-js";
export const pusher = new Pusher("c8b849ca67e195919255", {
  cluster: "ap2",
});
export const prodPusher = new Pusher("f196fcb7170d0fdfce1d", {
  cluster: "us2",
});
